export const InputPagesMixin = {
    data () {
        return {
            addOverlay: false,
            changeOverlay: false,
            dialog: false,
            process: {
                result: '',
                resultText: '',
                processing: false
            },
            lazy: false,
            valid: true,
            modeStatus: ''
        };
    }
};
